import {Action, Module, Mutation, VuexModule} from "vuex-module-decorators";
import {Actions, Mutations} from "@/store/enums/StoreEnums";
import MasterProviderService from "@/core/services/MasterProviderService";

@Module
export default class MasterProviderModule extends VuexModule {
  page: any = {
    loading: true,
    data: {
      total: 0,
      data: [],
      pages: 0,
    }
  }
  entity: any = {};

  @Action
  [Actions.LOAD_MASTER_PROVIDERS](filter) {
    MasterProviderService.findAll(filter).then(res => {
      this.context.commit(Mutations.SET_MASTER_PROVIDERS, {loading: false, data: res})
    })
  }

  @Action
  [Actions.LOAD_MASTER_PROVIDER](id) {
    this.context.commit(Mutations.SET_ENTITY_LOADING, true)
    MasterProviderService.get(id).then(res => {
      this.context.commit(Mutations.SET_MASTER_PROVIDER, res)
      this.context.commit(Mutations.EMIT_ACTIVITY_ACCESS, {
        createActivities: true,
        viewPendingActivities: true
      })
      this.context.commit(Mutations.EMIT_DOCUMENT_ACCESS, {uploadDocument: true})
    }).finally(() => {
      this.context.commit(Mutations.SET_ENTITY_LOADING, false)
    })
  }

  @Mutation
  [Mutations.SET_MASTER_PROVIDERS](payload) {
    this.page = payload;
  }

  @Mutation
  [Mutations.SET_MASTER_PROVIDER](payload) {
    this.entity = payload
  }
}
